KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.4';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      globofilter.toggleCanvas()
      // e.preventDefault();
      // document.getElementById('site-filters').show();
      // document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// ============ Announcement bar and Europe Site Redirection pop up code ================ // 
var location_json = "https://ipinfo.io?token=bd1b52a961e0eb";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

function setCookie(name, value, hours) {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + (hours * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + expiry.toUTCString() + "; path=/";
}

// Always check, not just from cookies
function fetchAndCompareCountryInfo() {
    $.ajax({
        url: location_json,
        crossDomain: true,
        type: 'GET',
        async: false,
        dataType: 'json',
        success: function(response) {
            // ALERT the country code
            // alert("Country code from API: " + response.country);

            const currentCountry = response.country;
            const currentTimeZone = response.timezone;
            const savedCountry = getCookie('CountryCode');
            const savedTimeZone = getCookie('CountryTimeZone');
            
            showRelevantAnnouncementBars(currentCountry);
            if (savedCountry !== currentCountry || savedTimeZone !== currentTimeZone) {
                setCookie('CountryCode', currentCountry, 2); // 2 hours
                setCookie('CountryTimeZone', currentTimeZone, 2);
                showAnnouncementBar(currentCountry);
              
                europianPopUp(currentTimeZone);
            } else {
                showAnnouncementBar(savedCountry);
                europianPopUp(savedTimeZone);
            }
        },
        error: function() {
            const countryCode = getCookie('CountryCode');
            const countryTimeZone = getCookie('CountryTimeZone');
            showAnnouncementBar(countryCode);
            europianPopUp(countryTimeZone);
            // alert("Failed to fetch location info.");
        }
    });
}


fetchAndCompareCountryInfo();

// showAnnouncementBar
function showAnnouncementBar(country_code) {
    var announcementSlider = document.querySelector('.announcement-bar__slider');
    if (!announcementSlider) {
        console.warn("Announcement slider element not found.");
        return;
    }
    const announcements = announcementSlider.getElementsByClassName('announcement');
    let foundMatch = false;
    // Check for matching announcements
    for (let announcement of announcements) {
        const dataCountryCode = announcement.getAttribute('data-attr');
        if (dataCountryCode === country_code || (dataCountryCode && dataCountryCode.includes(country_code))) {
            announcement.style.display = 'block';
            foundMatch = true;
        } else {
            announcement.style.display = 'none';
        }
    }
    // Handle "Other" announcement if no country match was found
    if (!foundMatch) {
        let otherValue = "";
        const otherAnnouncementElement = document.querySelector('.announcement[data-attr="Other"]');
        if (otherAnnouncementElement) {
            otherValue = otherAnnouncementElement.textContent.trim();
        }
        if (otherValue !== "") {
            // Hide all and show only "Other"
            for (let announcement of announcements) {
                announcement.style.display = 'none';
            }
            otherAnnouncementElement.style.display = 'block';
        } else {
            // Hide the entire bar if no match and no "Other"
            const announcementBar = document.querySelector('announcement-bar');
            if (announcementBar) {
                announcementBar.style.display = 'none';
            }
        }
    }
    // If a match was found, the `else` block is not needed as announcements are already handled.
}
function showRelevantAnnouncementBars(detectedCountry) {
  // For every announcement bar section on the page
  document.querySelectorAll('announcement-bar').forEach(function(bar) {
    var announcementSlider = bar.querySelector('.announcement-bar__slider');
    if (!announcementSlider) return;

    var announcements = announcementSlider.querySelectorAll('.announcement');
    var foundMatch = false;

    // Hide all, unless match
    announcements.forEach(function(announcement) {
      var blockCountryCodes = (announcement.getAttribute('data-attr') || "").split(',');
      // Trim spaces and compare
      if (blockCountryCodes.map(code => code.trim()).includes(detectedCountry)) {
        announcement.style.display = 'block';
        foundMatch = true;
      } else {
        announcement.style.display = 'none';
      }
    });

    // Optional: Handle "Other" block if configured and no matches
    if (!foundMatch) {
      var otherAnnouncement = announcementSlider.querySelector('.announcement[data-attr="Other"]');
      if (otherAnnouncement) {
        otherAnnouncement.style.display = 'block';
        foundMatch = true;
      }
    }

    // Show/hide the bar section accordingly
    bar.style.display = foundMatch ? 'block' : 'none';
  });
}

// For the European pop up
function europianPopUp(countryTimeZone) {
    var modal = document.getElementById('modal');
    if (!modal) {
        console.warn("Modal element not found.");
        return;
    }
    const countryCodeUk = getCookie('CountryCode');
    const isPopupClosed = getCookie('popupClosed');
    if (countryTimeZone && countryTimeZone.includes('Europe') && isPopupClosed !== 'true' && countryCodeUk !== "GB") {
        modal.style.display = 'block';
    } else {
        modal.style.display = 'none';
    }
    const closeBtn = document.querySelector('#modal .close');
    const closeButtonGlobal = document.getElementById('close-btn');
    const handleClose = function() {
        modal.style.display = 'none';
        const twoHoursFromNow = new Date();
        twoHoursFromNow.setTime(twoHoursFromNow.getTime() + 2 * 60 * 60 * 1000);
        document.cookie = "popupClosed=true; expires=" + twoHoursFromNow.toUTCString() + "; path=/";
    };
    if (closeBtn) {
       closeBtn.addEventListener('click', handleClose);
    }
    if (closeButtonGlobal) {
        closeButtonGlobal.addEventListener('click', handleClose);
    }
}
document.querySelectorAll('.announcement-bar__slider').forEach(function(slider) {
    // Count how many announcements are visible
    var visibleCount = 0;
    slider.querySelectorAll('.announcement').forEach(function(ann) {
        if (ann.style.display !== "none") visibleCount++;
    });
    // Get left/right arrow navs within this bar
    var navLeft = slider.parentElement.querySelector('.announcement-bar__content-nav--left');
    var navRight = slider.parentElement.querySelector('.announcement-bar__content-nav--right');
    // Show arrows only if 2 or more announcements are visible
    var showArrows = visibleCount > 1;
    if (navLeft)  navLeft.style.display  = showArrows ? 'inline-flex' : 'none';
    if (navRight) navRight.style.display = showArrows ? 'inline-flex' : 'none';
});

// ========= END =============== //